// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FEEDBACK_SUBMITTED_SUCCESSFULY = "\u010eakujeme za tvoje pripomienky.";
export const FORMS_DEFAULT_REQUIRED_FIELD_ERROR = "Toto pole je povinn\u00e9.";
export const NO = "Nie";
export const SEND = "Odo\u0161li";
export const WAS_THIS_ARTICLE_HELPFUL = "Pomohol ti tento \u010dl\u00e1nok?";
export const WIKI_I_WAS_MISSING = "Ch\u00fdbalo mi...";
export const WIKI_WE_ARE_HAPPY_ABOUT_IT = "To sme radi :-)";
export const WIKI_WHAT_WAS_MISSING = "\u010co ti v \u010dl\u00e1nku ch\u00fdbalo?";
export const WIKI_YES_THANK_YOU = "\u00c1no, v\u010faka!";
export const WIKI_YOU_CAN_SHARE_YOUR_EXPERIENCE_WITH_title_BELOW = "O svoju sk\u00fasenos\u0165 %(title)s sa m\u00f4\u017ee\u0161 podeli\u0165 ni\u017e\u0161ie";
